<div class="dialog-container addmasterproduct">
  <div class="dialog-title-block">
      <h2>Add Product</h2>
      <div class="flex-container gap-2">
          <div class="dialog-btn" (click)="onClose()">
              <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
          </div>
      </div>
  </div>
  <form #f="ngForm" name="form" novalidate>
      <div class="dialog-content-block p-3"> 
          <div class="d-flex gap-5 w-100 mt-4">
              <div class="w-50 d-flex flex-column">
                  <div class="form-group">
                      <div class="cabinet-dropdown stores">
                          <h6 class="text-start text-dark">Product Category</h6>
                          <div class="w-100">
                            <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isCategoryDropDown.set(!isCategoryDropDown())">
                                <span>{{ selectedCategory.value }}</span>
                                <img src="../../../assets/images/dropdown.png" [class]="isCategoryDropDown() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
                            </span>
                            <ul class="dropdown-menu dropdown-content" [class]="isCategoryDropDown() ? 'd-block' : ''">
                                <li *ngFor="let category of categories" class="dropdown-item" (click)="onCategoryTypeChange(category)">{{ category.value }}</li>
                            </ul>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="w-50 d-flex flex-column">
                  <div class="form-group">
                      <div class="cabinet-dropdown stores">
                          <h6 class="text-start text-dark">Body part</h6>
                          <div class="w-100">
                            <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isBodyPartDropDown.set(!isBodyPartDropDown())" [class.disabled]="isBodyPartDisabled">
                                <span>{{ selectedBodyPart.value }}</span>
                                <img src="../../../assets/images/dropdown.png" [class]="isBodyPartDropDown() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
                            </span>
                            <ul class="dropdown-menu dropdown-content" [class]="isBodyPartDropDown() ? 'd-block' : ''">
                                <li *ngFor="let bodyPart of bodyParts" class="dropdown-item" (click)="onBodyTypeChange(bodyPart)">{{ bodyPart.value }}</li>
                            </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div> 
          <div class="d-flex gap-5 w-100 mt-4">
              <div class="w-50 d-flex flex-column">
                  <div class="form-group">
                      <div class="cabinet-dropdown stores">
                          <h6 class="text-start text-dark">Implant</h6>
                          <div class="w-100">
                            <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isImplantDropDown.set(!isImplantDropDown())" [class.disabled]="isImplantDisabled">
                                <span class="selectedinput-content">{{ selectedImplant.value }}</span>
                                <img src="../../../assets/images/dropdown.png" [class]="isImplantDropDown() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
                            </span>
                            <ul class="dropdown-menu dropdown-content" [class]="isImplantDropDown() ? 'd-block' : ''">
                                <li *ngFor="let implant of implants" class="dropdown-item" (click)="onImplantTypeChange(implant)">{{ implant.value }}</li>
                            </ul>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="w-50 d-flex flex-column">
                  <div class="form-group">
                      <h6 class="text-start text-dark">Product Code</h6>
                      <input type="text" name="product_code" [(ngModel)]="code" value="" placeholder="Product Code">
                      <div class="form-error-msg"></div>
                  </div> 
              </div>
          </div>
          <div class="form-group">
              <h6 class="text-start text-dark">Product Name</h6>
              <input type="text" name="product_name" [(ngModel)]="name" value="" placeholder="Product Name">
              <div class="form-error-msg"></div>
          </div> 
          <div class="form-group">
            <h6 class="text-start text-dark">Product Image</h6>
            <div class="w-100 bg-blue-100 file-drop-wrapper mb-2">
                <div id="drag-area"
                    class="d-flex justify-content-center align-items-center p-3"
                    (drop)="dropFile($event)"
                    (dragover)="dragOverFile($event)"
                    (dragleave)="dragLeaveFile($event)">
                <div class="text-center" *ngIf="!uploadedFile && !imageUrl">
                    <img class="mb-2" src="../../../assets/images/add_new.svg" alt="add">
                    <p class="text-para text-dark">Drop files here</p>
                    <span class="text-para text-dark">or&nbsp;</span>
                    <button type="button" (click)="browseFile($event)" class="text-primary text-para fw-semibold bg-transparent text-decoration-underline">Browse</button>
                    <input (change)="onFileChange($event)" accept=".png,.jpg" type="file" id="file-input-add" hidden>
                </div>

                <!-- Preview Image -->
                <div class="text-center" *ngIf="uploadedFile || imageUrl">
                    <img [src]="uploadedFilePreview  || imageUrl" class="img-thumbnail mb-2" style="max-height: 100px;">
                    <div>
                    <button type="button" class="btn btn-sm btn-danger" (click)="removeImage()">Remove</button>
                    </div>
                </div>
                </div>
            </div>
        </div>

          <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center gap-1">
                  <img src="../../../assets/images/information.svg" alt="info" srcset="">
                  <p class="text-para text-light-dark">
                      Required format: PNG, JPG. Size: Maximum 5MB
                  </p>
              </div>
          </div>
      </div>
      <div class="dialog-footer">
          <button type="button" (click)="onClose()">Cancel</button>
          <button class="primary-btn addproduct" type="submit" (click)="onAdd()">Add</button>
      </div>
  </form>
</div>
